import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { FiscalYearRegion, Payload } from './fiscalYearRegion.model';
import fiscalYearRegionService from './fiscalYearRegion.service';

// namespace
export const FISCALYEAR_REGION_STORE_NAMESPACE = 'fiscalYearRegionStore';

// state
interface FiscalYearRegionState {
  fiscalYearRegions: FiscalYearRegion[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: FiscalYearRegionState = {
  fiscalYearRegions: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<FiscalYearRegionState> = {
  [mutationConstant.FETCH]: (state: FiscalYearRegionState, fiscalYearRegions: FiscalYearRegion[]) => {
    state.fiscalYearRegions = fiscalYearRegions;
  },
  [mutationConstant.PENDING]: (state: FiscalYearRegionState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: FiscalYearRegionState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: FiscalYearRegionState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch'
};

const action: ActionTree<FiscalYearRegionState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<FiscalYearRegionState, RootState>, payload: Payload) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      fiscalYearRegionService.Fetch(payload.fiscalYearId)
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  }
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<FiscalYearRegionState, RootState> = {
  [getterConstant.ALL]: (state: FiscalYearRegionState) => state.fiscalYearRegions,
  [getterConstant.BY_ID]: (state: FiscalYearRegionState) => (id: number) => state.fiscalYearRegions.find(m => m.id === id),
  [getterConstant.STATUS]: (state: FiscalYearRegionState) => state.status,
};

// module
const module: Module<FiscalYearRegionState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const FiscalYearRegionGetter = {
  ALL: `${FISCALYEAR_REGION_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${FISCALYEAR_REGION_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${FISCALYEAR_REGION_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const FiscalYearRegionAction = {
  FETCH: `${FISCALYEAR_REGION_STORE_NAMESPACE}/${actionConstant.FETCH}`
};

export default module;
